import { useEffect, useState, useContext } from "react";
import { LangContext } from "../../context/LangContext";
import useViewport from "../../hooks/useViewport";
import Paging from '../../components/Paging';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./style.css"

function Illustrations() {
    const { isDesktop } = useViewport();
    const { translations } = useContext(LangContext);

    const [page, setPage] = useState(0);
    const [counter, setCounter] = useState(-1);
    const [imgSize, setImgSize] = useState(null);
    const [illustrations, setIllustrations] = useState([]);

    useEffect(() => {
        const fetchIllustrations = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/get`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };

            const response = res.sort((a, b) => a.order - b.order);
            const chunkSize = isDesktop ? 15 : 10;
            const chunkedData = [];

            for (let i = 0; i < response.length; i += chunkSize) {
                const chunk = response.slice(i, i + chunkSize);
                chunkedData.push(chunk);
            }

            setIllustrations(chunkedData);
            setPage(0);
        }
        fetchIllustrations();
    }, [isDesktop]);

    useEffect(() => {
        if (counter === -1 || !illustrations[page][counter].image[`${isDesktop ? '' : '_'}url`]) {
            setImgSize(null)
            return;
        }

        const img = new Image();
        img.src = illustrations[page][counter].image[`${isDesktop ? '' : '_'}url`];

        img.onload = () => {
            setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
        };
    }, [counter, illustrations, isDesktop, page]);

    const prev = () => {
        const pageLength = illustrations[page].length;

        if (counter === 0) {
            if (page === 0) return
            setPage(page - 1);
            setCounter(pageLength - 1);
            return
        }
        setCounter(counter - 1);
    }

    const next = () => {
        const chunkSize = isDesktop ? 15 : 10;
        const pageLength = illustrations[page].length;

        if (counter === pageLength - 1) {
            if (pageLength !== chunkSize) return
            setPage(page + 1);
            setCounter(0);
            return
        }
        setCounter(counter + 1);
    }

    return illustrations.length !== 0 && (
        <div className='page page_illustrations'>
            <p className="title_page">-<span>Illustrations</span>-</p>

            <section className="sect_illustrations">
                <ul className="illustrations_list">
                    {illustrations[page].map((illust, idx) =>
                        <li key={idx}>
                            <button onClick={() => setCounter(idx)}>
                                <div className="preview">
                                    <i className="img" style={{ backgroundImage: `url(${illust.image._url})` }}></i>
                                    <p className="hover">-<span>{translations.view}</span>-</p>
                                </div>

                                <h2>- {illust.title} -</h2>
                            </button>
                        </li>
                    )}
                </ul>

                {illustrations.length > 1 && <Paging data={illustrations} page={page} setPage={setPage} />}
            </section>

            {imgSize && counter !== -1 &&
                <div className="mdl_illustration">
                    <button className="close_mdl" onClick={() => setCounter(-1)} />

                    <div className="content">
                        <div className="view">
                            <i className='img' style={{
                                backgroundImage: `url(${illustrations[page][counter].image[`${isDesktop ? '' : '_'}url`]})`,
                                aspectRatio: `${imgSize.width} / ${imgSize.height}`
                            }} />

                            <button className='left_illustration btn_switch' onClick={() => prev()}>
                                <FaChevronLeft />
                            </button>

                            <button className='right_illustration btn_switch' onClick={() => next()}>
                                <FaChevronRight />
                            </button>
                        </div>

                        <div className="mdl_descrip">
                            <p><span>{translations.title} :</span>{illustrations[page][counter].title}</p>
                            <p><span>{translations.serie} :</span>{illustrations[page][counter].serie}</p>
                            <p><span>Personnage :</span>{illustrations[page][counter].perso}</p>
                            <p><span>{translations.date_of_creation} :</span>{illustrations[page][counter].created}</p>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Illustrations;